import { useMemo } from "react";

import { transformIntermodalRouteToDropdownOption } from "../../use-cases/intermodal/utils/detailsUtils";
import { useAllIntermodalRoutes } from "./useAllIntermodalRoutes";

export interface IntermodalRouteDropdownOption {
  id: string;
  longDescription: string;
}

export const useAllIntermodalRoutesAsOptions = () => {
  const { allIntermodalRoutes, error } = useAllIntermodalRoutes();

  const intermodalRouteOptions = useMemo(() => {
    return allIntermodalRoutes.map((route) =>
      transformIntermodalRouteToDropdownOption(route),
    );
  }, [allIntermodalRoutes]);
  return { intermodalRouteOptions, error };
};
